import { render, staticRenderFns } from "./MediumImage.vue?vue&type=template&id=5da6553f&scoped=true"
import script from "./MediumImage.vue?vue&type=script&lang=js"
export * from "./MediumImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6553f",
  null
  
)

export default component.exports